import React from "react";
import { rgba, tint, shade } from "polished";
import styled from "styled-components";
import * as Clrs from "../../src/js/colors";

const YearContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;
  align-items: flex-start;
  margin-bottom: 16px;
`;
const PaintingBlock = styled.div`
  display: flex;
  flex-wrap: wrap;
  border: 1px solid ${Clrs.grey};

  background-color: rgba(0, 0, 0, 0.4);
  flex: 0 0 auto;
`;

const YearText = styled.div`
  background-color: ${Clrs.pink};
  padding: 4px;
  font-size: 11px;
  color: ${Clrs.white};
  border-radius: 4px 4px 0 0;
  font-weight: 700;
  flex: 0 0 auto;
  margin-left: 8px;
`;

const ThumbContainer = styled.div`
  border: 3px solid ${Clrs.light};
  height: 200px;
  width: 100%;
  min-width: ${(props) =>
    props.narrow ? "100px" : props.wide ? "200px" : "150px"};
  display: flex;
  position: relative;
  background-image: url(${(props) => props.bgimg});
  background-size: cover;
  background-position: center;
  //margin: 8px;
  cursor: pointer;
  /* width: ${(props) =>
    props.narrow
      ? "150px"
      : props.medium
      ? "200px"
      : props.wide
      ? "300px"
      : "200px"}; */
  img {
    max-width: 100%;
    object-fit: cover;
  }
  &:hover {
    div {
      height: 100%;
    }
  }
`;

const PaintingOverlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.7);
  overflow: hidden;
  width: 100%;
  height: 0;
  transition: 0.5s ease;
`;

const Title = styled.p`
  color: ${Clrs.lightgreen};
  font-size: 16px;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 90%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
`;

const SoldBadge = styled.div`
  position: absolute;
  right: 0%;
  bottom: 0%;
  background-color: ${Clrs.lightblue};
  color: white;
  padding: 6px;
  font-size: 12px;
`;

function Year(props) {
  return (
    <YearContainer>
      <YearText>{props.yr}</YearText>
      <PaintingBlock>{props.children}</PaintingBlock>
    </YearContainer>
  );
}
const BoxLabel = styled.div`
  position: absolute;
  ${(props) =>
    props.labelposition === "right" ||
    (!props.labelposition &&
      `
    right: 10px;
  `)}
  ${(props) =>
    props.labelposition === "left" &&
    `
    left: 10px;
  `}
  
  top: -20px;
  height: 20px;
  display: flex;
  padding: 0px 8px;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  background-color: ${(props) =>
    props.labelcolor ? props.labelcolor : Clrs.basegrey};
  color: ${Clrs.darkgrey};
`;

function Painting(props) {
  return (
    <ThumbContainer
      onClick={props.onClick}
      narrow={props.narrow}
      medium={props.medium}
      wide={props.wide}
      bgimg={props.bgimg}
    >
      <PaintingOverlay>
        <Title>{props.txt}</Title>
      </PaintingOverlay>
      {props.flag && <SoldBadge>{props.flag}</SoldBadge>}
      {props.label && (
        <BoxLabel
          labelcolor={props.labelcolor}
          labelposition={props.labelposition}
        >
          {props.label}
        </BoxLabel>
      )}
      {props.children}
    </ThumbContainer>
  );
}

export { Painting, Year };
